import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class CustomFormValidatorsService {
    /**
     * This validator makes a form control required or not depending of a condition, e.g. another control has to be set to make the control required
     *
     * @param inputName Form control name to make required or not
     * @param requiredWhen Function to check if the control is required or not
     */
    conditionalRequiredValidator(inputName: string, requiredWhen: (form: FormGroup) => boolean): ValidatorFn | null {
        return (form: AbstractControl): ValidationErrors | null => {
            const targetInput: AbstractControl | null = form.get(inputName);

            if (targetInput) {
                const isRequired = requiredWhen(form as FormGroup);

                if (isRequired !== targetInput.hasValidator(Validators.required)) {
                    if (isRequired) {
                        targetInput.addValidators(Validators.required);
                    } else {
                        targetInput.removeValidators(Validators.required);
                    }

                    targetInput.updateValueAndValidity({ onlySelf: true });
                }
            }

            return null;
        };
    }
}
